import { LINK_ENTITY_TYPE } from '../../constants/linkConstants';
import { EditorState, RichUtils, SelectionState } from 'draft-js';
export var useLinkHelpers = function (editorState, setEditorState, editorReference) {
    var addLink = function (urlValue) {
        var contentState = editorState.getCurrentContent();
        var contentStateWithEntity = contentState.createEntity(LINK_ENTITY_TYPE, 'MUTABLE', { url: urlValue });
        var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        var newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity });
        var currentSelection = newEditorState.getSelection();
        var toggledLinkState = RichUtils.toggleLink(newEditorState, currentSelection, entityKey);
        // set new editor state with selection forced after
        var keyAfterLink = currentSelection.getIsBackward() ? currentSelection.getAnchorKey() : currentSelection.getFocusKey();
        var offSetAfterLink = currentSelection.getIsBackward() ? currentSelection.getAnchorOffset() : currentSelection.getFocusOffset();
        var selectionAfterLink = new SelectionState({
            anchorKey: keyAfterLink,
            anchorOffset: offSetAfterLink,
            focusKey: keyAfterLink,
            focusOffset: offSetAfterLink,
            isBackward: false,
        });
        setEditorState(EditorState.forceSelection(toggledLinkState, selectionAfterLink));
        setTimeout(function () {
            var editor = editorReference.current;
            if (editor) {
                editor.focus();
            }
        }, 0);
    };
    var clearLink = function () {
        var selection = editorState.getSelection();
        if (!selection.isCollapsed()) {
            setEditorState(RichUtils.toggleLink(editorState, selection, null));
        }
    };
    var showLinkPrompt = function (setUrlValue, setShowUrlInput) {
        var selection = editorState.getSelection();
        if (!selection.isCollapsed()) {
            var contentState = editorState.getCurrentContent();
            var startKey = selection.getStartKey();
            var startOffset = selection.getStartOffset();
            var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
            var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
            var url = '';
            if (linkKey) {
                var linkInstance = contentState.getEntity(linkKey);
                url = linkInstance.getData().url;
            }
            // set state for current link value and display the input
            setUrlValue(url);
            setShowUrlInput(true);
        }
    };
    return {
        addLink: addLink,
        clearLink: clearLink,
        showLinkPrompt: showLinkPrompt,
    };
};
//# sourceMappingURL=useLinkHelpers.js.map